import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { AddProWakel } from "./Context/AddProWakel";

ReactDOM.render(
  <AddProWakel>
    <App />
  </AddProWakel>,
  document.getElementById("root")
);

serviceWorker.unregister();
